import { Command } from 'commander';
import { detectWorkspace, folderForSelector, readMeta } from '../config-as-code/workspace.js';
import { readBinding, writeBinding } from '../database-binding.js';

export const useCommand = new Command('use')
  .description('Bind this worktree to a database so push/pull refuse to run against a different one')
  .argument('<database>', 'Database id (e.g. prod--my-preview), or a folder name under rekor-ws/databases')
  .action(async (selector: string) => {
    const databaseId = resolveSelectorToDatabaseId(selector);

    const previous = readBinding();
    if (previous === databaseId) {
      console.log(`Worktree already bound to ${databaseId}.`);
      return;
    }

    writeBinding(databaseId);
    if (previous) {
      console.log(`Worktree rebound: ${previous} → ${databaseId}.`);
    } else {
      console.log(`Worktree bound to database ${databaseId}.`);
    }
  });

/**
 * Resolve a `use` selector to a database id: if it names a tracked folder under `rekor-ws/databases`
 * (one with a `database_id`), use that id; otherwise treat the selector as the literal id. Mirrors
 * wayai's "UUID or folder name" so `rekor use my-preview` and `rekor use prod--my-preview` both work.
 */
function resolveSelectorToDatabaseId(selector: string): string {
  const ws = detectWorkspace();
  if (ws) {
    const meta = readMeta(folderForSelector(ws, selector));
    if (meta?.database_id) return meta.database_id;
  }
  return selector;
}
